import { CreateOrEditScheduleViewModelMapper } from './CreateOrEditScheduleViewModelMapper';
import { DeleteContentsAction } from '../../content/services/DeleteContentsAction';
import { editSelfServiceSchedule } from '../../app/sagas/spaces/ScheduleMenuSagas';
import { FeatureFlags } from '../FeatureFlags';
import { IContentInfo } from '../models/IContentInfo';
import { IMainScope } from '../../app/IMainScope';
import { ISchedule } from '../../schedule/types/ISchedule';
import { IScheduleViewModel } from './CreateOrEditScheduleCtrl';
import { Module } from '../Module';
import { SetScheduleStatusActionService } from '~src/schedule/actions/SetScheduleStatusAction';
import { ToasterService } from '../services/ToasterService';
import { SchedulePermissionsService } from '../services/SchedulePermissions';
import { CreateOrUpdateScheduleActionService } from '../services/CreateOrUpdateScheduleAction';

export interface ISchedulePlaceScope extends IMainScope {
  // comes from parent scope (angular directive in ScheduleSpace)
  schedule: ISchedule;
  scheduleDescription: string;
  scheduleActionName: string;
  navigateToAllSchedules: () => void;
  reloadSpace: () => void;

  scheduleViewModel: IScheduleViewModel;
  scheduleStatus: { enabled: boolean };
  scheduledActionType: string;

  editMode: boolean;
  busy: boolean;
  beginEdit: ($event: JQueryEventObject) => void;
  cancelEdit: ($event: JQueryEventObject) => void;
  save: ($event: JQueryEventObject) => void;

  del: ($event: JQueryEventObject) => void;

  // Permissions
  canEditSchedule: () => boolean;
}

export class ScheduleSpaceDetailsCtrl {

  public static $inject = [
    '$scope'
  ];

  constructor(
            $scope: ISchedulePlaceScope,
  ) {
    const schedule = $scope.schedule;

    $scope.canEditSchedule = () => SchedulePermissionsService.canEditSchedule();

    $scope.scheduledActionType = schedule.scheduledAction;

    // Edit schedule
    $scope.beginEdit = () => {
      if (FeatureFlags.adminSelfServiceSchedulesEnabled) {
        editSelfServiceSchedule($scope.schedule as any).then(() => {
          $scope.reloadSpace();
        });
      } else {
        $scope.scheduleViewModel = CreateOrEditScheduleViewModelMapper.viewModelFromSchedule($scope.schedule);
        $scope.editMode = true;
      }
    };
    $scope.cancelEdit = () => $scope.editMode = false;
    $scope.save = ($event: JQueryEventObject) => {
      $scope.busy = true;
      CreateOrUpdateScheduleActionService.submitScheduleUpdate($scope.scheduleViewModel, $scope.schedule.name)
        .then(() => {
          $scope.editMode = false;
          $scope.reloadSpace();
        })
        .finally(() => $scope.busy = false);
    };

    $scope.scheduleStatus = {
      enabled: !!schedule.runNextAt
    };
    $scope.$watch('scheduleStatus.enabled', (newVal: boolean, oldVal: boolean) => {
      if (newVal !== oldVal) {
        const action = newVal
          ? SetScheduleStatusActionService.enableSchedule(schedule)
          : SetScheduleStatusActionService.disableSchedule(schedule);
        action.then(() => $scope.reloadSpace());
      }
    });

    const scheduleInfo = {...schedule, contentType: 'schedule'} as unknown as IContentInfo;

    $scope.del = ($event: JQueryEventObject) => {
      DeleteContentsAction.confirmDeleteContents([scheduleInfo])
        .then(() => {
          ToasterService.instance.markToastsAsDoNotDismissOnLocationChange();
          $scope.navigateToAllSchedules();
        });
    };
  }
}

Module.instance().controller('ScheduleSpaceDetailsCtrl', ScheduleSpaceDetailsCtrl);
